import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { HttpRequestsService } from '@core/infrastructure/http-requests/http-requests.service';

@Injectable()
export class SeoApiRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
    ) {}

    public getCategoryTranslations(
        categoryId: string | number,
        storeId: string,
    ): Observable<any> {
        return this.http.get<any>(
            this.requestService.requestUrl(
                `catalog/store/${storeId}/category/${categoryId}/seolang`,
                undefined,
                [
                ],
                true,
                '1'
            ),
            { withCredentials: true }
        ).pipe(
            catchError(() => of(null))
        );
    }
}
